import * as mq from './mq';


const setViewport = () => {

  let meta = document.querySelector('meta[name=viewport]');

  if(!meta) {
    return;
  }


  if(mq.matchesNarrow()) {

    meta.setAttribute('content', 'width=375, shrink-to-fit=no');
  }
  else if(mq.matchesWide()) {

    meta.setAttribute('content', 'width=1480, shrink-to-fit=no');
  }
};

export default setViewport;



// WEBPACK FOOTER //
// ./src/js/setViewport.js